import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TSmeShareContext, IDeps } from './models';
import { SmeShareContext as Component } from './sme-share-context';

export const SmeShareContext = createWidget<IDeps, TSmeShareContext>({})(Component);
